<template>

    <div class="show_img" >

<!--        <transition>-->
<!--        主视图-->
        <el-carousel v-if="goods.length > 0"  class="el-image pmd" ref="carousel"  @click.native="tovr"  name="index" height="550px" :interval="5000" arrow="always" indicator-position="none" :autoplay="false" :loop="false">
            <el-carousel-item  v-for="(item,i) in goods"  style="background-size: 100% 100%;" :key="i" :style="'background-image: url('+item+')'">
<!--                <img :src="item" class="item-imgs" preview="0" preview-text="预览" style="width: auto;background-size: 100% 100%" alt="">-->
            </el-carousel-item>
            <el-image :preview-src-list="goods" :src="fda" class="suofang"
                      style="z-index: 100;height: 24px;padding: 12px;width: 24px;background-color: rgba(0,0,0,.3);position: absolute;bottom: 0;right: 0;"
                      :lazy="true">
            </el-image>
        </el-carousel>
        <div v-else style="height: 550px;display: flex;align-items: center;justify-content: center;" class="el-image pmd"><img height="40" src="../assets/svg/nullImg.svg" alt=""></div>
<!--            <img  style="background-size: 100% 100%" :src="srcIndex"  alt="">-->
<!--            <el-image :preview-src-list="goods" :src="srcIndex"  style="background-size: 100% 100%" :lazy="true"></el-image>-->
<!--        </transition>-->
        <!--            轮播选择-->
        <div class="imgsCroll flex justify-between">
            <div class="selesty fl" @click="clickRight"> <</div>

            <div class="wrapper">
                <ul ref="content" class=" dinwei" :style="scrollValue">
                    <li v-for="(item,i) in goods" :key="i" class="item" @mousemove="moveCheck(i)">
                        <img :src="item" alt=""
                             style="background-size: 100% 100%;height: 75px;width: 75px;border-radius: 5px">
                    </li>
                </ul>
            </div>
<!--            调comp属性。隐藏-->
            <div v-show="false">{{comp}}{{isvrSu}}{{urlDataf}}</div>
            <div class="selesty" @click="clickLeft"> ></div>
        </div>

    </div>


</template>

<script>
    export default {
        data() {
            return {
                isclickt: false,
                fda: require('../assets/png/fda.png'), // 放大图标
                goods: [],  // 图组
                scrollValue: 'transform: translateX(0px) translateY(0px) translateZ(1px);',
                Xscroll: 0, // 横向X坐标控制
                lines: null,
                srcIndex: null, // 当前主视图显示
            }
        },
        props: {
            scrollData: {
                type: Array,
                default: []
            },
            isvr:{
                type:Boolean,
                default: false
            },
            urlData:{
                type: Array,
                default: []
            }
        },
        computed: {
            comp(){ // 检测数据更新视图a
                this.goods = this.scrollData
                this.srcIndex = this.goods[0]
                return this.scrollData
            },
            isvrSu(){
                return this.isvr
            },
            urlDataf(){
                return this.urlData
            }
        },
        created() {
            this.goods = this.scrollData
            this.srcIndex = this.goods[0]
        },
        methods: {
            tovr(){
                console.log(this.isvr)
                let activeIndex = this.$refs.carousel.activeIndex
                console.log('点击',activeIndex)
                // 判断全景图类型
                if(this.isvr){
                    this.$router.push({path: '/vrview' ,query: {url:this.urlDataf[activeIndex].vrImgUrl,type:this.urlDataf[activeIndex].type}})
                }
            },
            // 向右偏移
            clickLeft() {
                this.next()
                if (this.goods.length >= 8) {
                    if (JSON.parse('-' + (this.goods.length - 8) * 90) <= this.Xscroll) {
                        console.log('aaaaaa', JSON.parse(this.goods.length - 8) * 90)
                        this.Xscroll -= 90
                        this.scrollValue = 'transform: translateX(' + this.Xscroll + 'px) translateY(0px) translateZ(1px);'
                    }
                }
            },
            // 向左偏移
            clickRight() {
                this.prev()
                if (this.Xscroll < 0) {
                    this.Xscroll += 90
                    this.scrollValue = 'transform: translateX(' + this.Xscroll + 'px) translateY(0px) translateZ(1px);'
                    console.log('bbbbbb')
                }
            },
            next(){
                this.$refs.carousel.next()
            },
            prev(){
                var activeIndex = this.$refs.carousel.activeIndex
                this.$refs.carousel.prev()
                console.log('prev',activeIndex)
            },
            setActiveItems(i){
                this.$refs.carousel.setActiveItem(i)
            },
            moveCheck(e) {
                console.log('moveCheck',e)
                this.setActiveItems(e)
                this.srcIndex = this.goods[e]
            },
            opacityIs(is){
                this.items.type = true
                for(var i = 0;i < this.items.length;i++){
                    if(i === is){
                        continue ;
                    }
                    this.items[i].type = false;
                }
            }
        },
    }
</script>

<style scoped>
    .el-image{

        background-color: #939393;
    }
    .pmd > .el-carousel__container {
        position: unset !important;
        height: 100% !important;
    }
    li {
        list-style-type: none;
    }

    .show_img {
        height: 656px;
        width: 800px;
    }

    .imgsCroll {
        /*width: 100%;*/
        position: relative;
        bottom: -27px;
        height: 80px;
        /*background-color: rgba(182,182,182,1);*/
    }

    .flex-center {
        display: flex;
        justify-content: center;
    }

    .wrapper {
        /*width: 400px;*/
        width: 100%;
        /*background-color: red;*/
        overflow: hidden;
        height: 80px;
        /*pointer-events: none !important; !*不能操作*!*/
    }

    .item {
        width: 75px;
        /*background-color: #dc00ac;*/
        margin-right: 20px;
        height: 75px;
        float: left;
        border: 2px white solid;
        border-radius: 5px;
    }

    .item:hover {
        border: 2px #ff5900 solid;
    }

    .dinwei {
        transition: all 1s;
        /*margin-left: 90px;*/
        position: relative;
        top: -15px;
        /*left: 110px;*/
        justify-content: start;
        display: flex;
    }

    .selesty {
        width: 34px;
        background-color: rgba(182, 182, 182, .5);
        border-radius: 5px;
        color: #fff;
        line-height: 75px;
        font-size: 18px;
        user-select: none;
    }

    .el-image {
        border-radius: 5px;
        width: 800px;
        height: 550px;
        transition: all 1s ease-in-out;
    }
    .el-carousel__item{
        opacity: 0.5;
    }
    .is-active{
        opacity: 1;
    }
    .el-carousel__item.is-animating{

        /*transition: opacity 1s  ease-out !important;*/
        transition: opacity 1s  ease-in-out !important;
    }
</style>